import ActiveSubscriptionPageGuard from './ActiveSubscriptionPageGuard';

export default ActiveSubscriptionPageGuard;
